import React, { useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import './FacilityModal.css';
import Button from '../Button';


interface ModalProps {
  contents: React.ReactNode;
  title: string;
  
  closeModal: () => void;
  
 showModal: boolean
}
const UserFacilityModal: React.FC<ModalProps> = ({
  closeModal,
  contents,
  title,
 
  showModal
}) => {
    const [show,setShow]=useState<boolean>(showModal);
    // const closeModal=()=>{
    //     setShow(false);
    // }
  return (
    <>
      <Modal
        show={show}
        onHide={closeModal}
        backdrop="static"
        keyboard={false}
        dialogClassName="custom_modal_page_user_facility"
      >
        <Modal.Header className="modal_page_header">
          <div className="modal_page_header1">
            <div className="modal_title">{title}</div>
            <Button
              onClick={closeModal}
              disabled={false}
              id=""
              buttonName={'Cancel'}
              colorType={'save'}
              icon={''}
              iconPosition={''}
            />
          </div>
          
        </Modal.Header>
        <Modal.Body className="page_modal_body">
          
                {contents}
            
        </Modal.Body>
        
      </Modal>
    </>
  );
};

export default UserFacilityModal;
